function collapseWhitespace(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

function shouldTitleCase(value: string): boolean {
  return value === value.toLowerCase() || value === value.toUpperCase();
}

function titleCaseToken(token: string): string {
  return token
    .split(/([\-'/])/)
    .map((segment) => {
      if (!segment || segment === '-' || segment === "'" || segment === '/') {
        return segment;
      }
      return `${segment.charAt(0).toUpperCase()}${segment.slice(1).toLowerCase()}`;
    })
    .join('');
}

export function formatSuburbLabel(value: unknown): string {
  const normalized = collapseWhitespace(String(value ?? ''));
  if (!normalized) return '';
  if (!shouldTitleCase(normalized)) return normalized;
  return normalized
    .split(' ')
    .map((token) => titleCaseToken(token))
    .join(' ');
}
